import { Component, OnInit } from '@angular/core';

// TODO: refactor using CMS
// NOTE: translations  nwo translate 50 into 60 !

@Component({
  selector: 'lc-instructions-page',
  templateUrl: './instructions-page.component.html',
  styleUrls: ['./instructions-page.component.scss']
})
export class InstructionsPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/instructions-page/instructions-page.component.ts